import {
  Autoplay,
  EffectCoverflow,
  FreeMode,
  Keyboard,
  Mousewheel,
  Navigation,
  Pagination,
  Scrollbar,
  Swiper,
  SwiperXComponent,
} from "@various/swiper";

Swiper.use([
  // -
  Autoplay,
  EffectCoverflow,
  FreeMode,
  Keyboard,
  Mousewheel,
  Navigation,
  Pagination,
  Scrollbar,
]);

export { SwiperXComponent };
